namespace advisorop.components.advisor {
    
    export class PopHhrNewTitleController {
        // bindings
        household: domains.IHousehold;
        advisoryFirm: domains.IAdvisoryFirm;
        cuAccount: CuAccountController;
        newAccount: domains.IAccount = { id: 0 };

        // bindings inherited from modal
        modalInstance: any; //angular.ui.bootstrap.IModalServiceInstance

        static $inject = ["advisorService", "generalService", "$scope"];
        constructor(
            private advisorService: advisorop.services.AdvisorService,
            private generalService: advisorop.services.GeneralService,
            private $scope: ng.IScope
        ) {
        }
        
        // default modal methods
        ok = () => {
            //console.log("PopHhr ok() function fired...");
            //console.log("This scope:", this.$scope);
            const $resolve = this.$scope.$parent.$resolve;

            const modal = (this.$scope.$parent.$uibModalInstance as angular.ui.bootstrap.IModalServiceInstance);
            
            if (this.cuAccount.validateAccountBasicInformationForm()) {

                this.cuAccount.bindAccountFromForm();

                // console.log("Account data filled in cu-account", this.cuAccount.account, this.newAccount);

                modal.close(this.newAccount);
            }
        };

        cancel = () => {
            this.$scope.$parent.$uibModalInstance.dismiss();
        };

        bindCuAccount(ctrl: CuAccountController) {
            this.cuAccount = ctrl;

            this.cuAccount.selAdvisoryFirm = {};

            angular.copy(this.advisoryFirm, this.cuAccount.selAdvisoryFirm);

            this.cuAccount.selHouseholdGroup = {};

            angular.copy(this.household, this.cuAccount.selHouseholdGroup);
        }
        
        // overrides
        $onInit(): void {
            // initialise modal
            const $resolve = this.$scope.$parent.$resolve;

            this.advisoryFirm = $resolve.advisoryFirm;

            this.household = $resolve.household;
        }
    }

    class PopHhrNewTitle implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = PopHhrNewTitleController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/pop-hhr-new-title.html";
        }
        
    }
    angular.module(Constants.APP).component("popHhrNewTitle", new PopHhrNewTitle());
}